import { PUBLIC_MEDIA } from '../branding/assets';

export const WHATSAPP_ICON_URL = PUBLIC_MEDIA.whatsappIcon;

const BRAZIL_AREA_CODES = new Set([
  '11', '12', '13', '14', '15', '16', '17', '18', '19',
  '21', '22', '24', '27', '28',
  '31', '32', '33', '34', '35', '37', '38',
  '41', '42', '43', '44', '45', '46', '47', '48', '49',
  '51', '53', '54', '55',
  '61', '62', '63', '64', '65', '66', '67', '68', '69',
  '71', '73', '74', '75', '77', '79',
  '81', '82', '83', '84', '85', '86', '87', '88', '89',
  '91', '92', '93', '94', '95', '96', '97', '98', '99',
]);

export const normalizeBrazilPhoneForWhatsapp = (phone) => {
  const raw = String(phone || '').trim();
  if (/^\+\s*(?!55)/.test(raw)) return '';

  let digits = raw.replace(/\D/g, '').replace(/^0+/, '');
  if (!digits) return '';

  if (digits.startsWith('55')) {
    const withoutCountryCode = digits.slice(2).replace(/^0+/, '');
    if (withoutCountryCode.length === 10 || withoutCountryCode.length === 11) {
      digits = withoutCountryCode;
    }
  }

  const hasValidAreaCode = BRAZIL_AREA_CODES.has(digits.slice(0, 2));
  const isLandline = /^[1-9][0-9][2-5][0-9]{7}$/.test(digits);
  const isMobile = /^[1-9][0-9]9[0-9]{8}$/.test(digits);
  return hasValidAreaCode && (isLandline || isMobile) ? `55${digits}` : '';
};

export const formatBrazilPhone = (phone) => {
  const normalized = normalizeBrazilPhoneForWhatsapp(phone);
  if (!normalized) return '';
  const national = normalized.slice(2);
  const ddd = national.slice(0, 2);
  const number = national.slice(2);
  const splitAt = number.length === 9 ? 5 : 4;
  return `+55 (${ddd}) ${number.slice(0, splitAt)}-${number.slice(splitAt)}`;
};

export const formatBrazilPhoneInput = (phone) => {
  let digits = String(phone || '').replace(/\D/g, '').replace(/^0+/, '');
  if (digits.startsWith('55') && digits.length > 11) digits = digits.slice(2);
  digits = digits.slice(0, 11);
  if (!digits) return '';
  if (digits.length <= 2) return `(${digits}`;
  const ddd = digits.slice(0, 2);
  const number = digits.slice(2);
  if (number.length <= 4) return `(${ddd}) ${number}`;
  const splitAt = number.length > 8 ? 5 : 4;
  return `(${ddd}) ${number.slice(0, splitAt)}-${number.slice(splitAt)}`;
};

export const buildWhatsappLink = (phone) => {
  const normalizedPhone = normalizeBrazilPhoneForWhatsapp(phone);
  return normalizedPhone ? `https://wa.me/${normalizedPhone}` : '';
};

/** Número comercial / vendas usado nas LPs e landing pages. */
export const SALES_WHATSAPP_PHONE = '5551984137718';

export const SALES_WHATSAPP_LINK = buildWhatsappLink(SALES_WHATSAPP_PHONE);

/** Link de vendas; `message` opcional (texto já sem encode). */
export const buildSalesWhatsappLink = (message) => {
  if (!SALES_WHATSAPP_LINK) return '';
  if (!message) return SALES_WHATSAPP_LINK;
  return `${SALES_WHATSAPP_LINK}?text=${encodeURIComponent(message)}`;
};
